import {useMutation} from "@tanstack/react-query";
import ENDPOINTS from "utils/requests/endpoints";
import axiosInstance from "utils/requests/axiosInstance";

export const logout = async () => {
    return await axiosInstance.post(
        process.env.REACT_APP_LOGIN_URL + ENDPOINTS.logout
    );
};

const useLogout = () => {
    return useMutation({
        mutationFn: logout,
    });
};

export default useLogout;
